import styled from 'styled-components';
import { FC, ReactNode } from 'react';

const StyledHeaderContainer = styled.div<{ $noBorder: boolean }>`
  display: flex;
  padding: 0 0 1rem;
  flex-direction: column;
  min-height: 51px;
  gap: 1rem;
  border-bottom: ${({ theme, $noBorder }) => $noBorder ? 'none' : `1px solid  ${theme.palette.grey}`};

  @media (min-width: 860px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

interface HeaderContainerProps {
  children: ReactNode;
  noBorder?: boolean;
}

export const HeaderContainer: FC<HeaderContainerProps> = ({ children, noBorder = false }) => (
  <StyledHeaderContainer $noBorder={noBorder}>{children}</StyledHeaderContainer>
);
